import { OverlayRef } from '@angular/cdk/overlay';
import { ToastContainer } from './toast-container.component';
import { Subject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export class ToastRef {
  public componentInstance: ToastContainer;

  constructor(private readonly overlayRef: OverlayRef) { }

  isVisible() {
    return this.overlayRef && this.overlayRef.overlayElement;
  }

  getPosition() {
    return this.overlayRef.overlayElement.getBoundingClientRect();
  }

  public close(data?: any): void {
    this.overlayRef.dispose();

    // tslint:disable-next-line: no-non-null-assertion
    this.componentInstance = null!;
  }
}
